import { BrowserRouter, Routes, Route, useParams, useSearchParams } from "react-router";
import EditorPage from "./pages/EditorPage";
import AuthCallback from "./pages/AuthCallback";
import ShareViewPage from "./pages/ShareViewPage";
import SharedDrawingPage from "./pages/SharedDrawingPage";
import ImpactDashboardPage from "./pages/ImpactDashboardPage";

/** Wrapper that keys EditorPage by file identity — forces full remount when
 *  navigating between files or returning to home.
 *  For new drawings, a `_ts` search-param ensures each "New drawing" action
 *  produces a unique key so React fully remounts even when already at `/`.
 *  For ephemeral rooms, the invite token is used as the key. */
function EditorPageKeyed() {
  const { driveId, itemId, drawingId, inviteToken } = useParams();
  const [searchParams] = useSearchParams();
  const ts = searchParams.get("_ts") ?? "";
  const key = drawingId
    ? `drawing-${drawingId}`
    : driveId && itemId
      ? `${driveId}/${itemId}`
      : inviteToken
        ? `room-${inviteToken}`
        : `new-${ts}`;
  return <EditorPage key={key} />;
}

export function AppRoutes() {
  return (
    <Routes>
      {/* Root renders the editor directly — gallery is embedded in the welcome screen */}
      <Route path="/" element={<EditorPageKeyed />} />
      {/* Scene-only room join — the token carries the room and the role it
          grants. There is deliberately no bare /room/:roomId route. */}
      <Route path="/join/:inviteToken" element={<EditorPageKeyed />} />
      <Route path="/drawing/:drawingId" element={<EditorPageKeyed />} />
      <Route path="/share/:blobId" element={<ShareViewPage />} />
      <Route path="/shared" element={<SharedDrawingPage />} />
      <Route path="/dashboard" element={<ImpactDashboardPage />} />
      {/* Auth callback — MSAL processes the redirect, then navigates to the original URL */}
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
